import type { Product } from '@/entities/product';
import { getMinPositivePrice } from '@/shared/lib/price';
import { isValidCoords } from './mercator';
import type { MapHotel } from '../model/types';

export function getMapProductPrice(product: Product): number | null {
  return getMinPositivePrice([product]);
}

function isCheaper(candidate: Product, current: Product): boolean {
  const candidatePrice = getMapProductPrice(candidate);
  const currentPrice = getMapProductPrice(current);

  if (candidatePrice === null) return false;

  return currentPrice === null || candidatePrice < currentPrice;
}

export function getCheapestHotelProducts(products: readonly Product[]): Product[] {
  const cheapestByHotel = new Map<number, Product>();

  products.forEach((product) => {
    if (!product.hotel) return;

    const current = cheapestByHotel.get(product.hotel.id);

    if (!current || isCheaper(product, current)) cheapestByHotel.set(product.hotel.id, product);
  });

  return [...cheapestByHotel.values()];
}

export function toMapHotels(products: readonly Product[]): MapHotel[] {
  return getCheapestHotelProducts(products).flatMap((product) => {
    const { hotel } = product;

    if (!hotel || !isValidCoords(hotel.coords)) return [];

    return [
      {
        hotelId: hotel.id,
        name: hotel.name,
        coords: { latitude: hotel.coords.latitude, longitude: hotel.coords.longitude },
        price: getMapProductPrice(product),
      },
    ];
  });
}
